export default ({ user }) => (
  <div class='reputation' style={{ width: '100%' }}>
    <div class={`reputation__level--${user.userLevel}`} />
  </div>
)
